$(document).on('change', '.results-per-page', function (e) {
  var url = new URL(location.href);
  //send user back to page 1
  url.searchParams.delete('page');
  //replace existing items per page parameter or add a new one
  url.searchParams.set('items_per_page', e.target.value);
  DK.Search.updateListing(url.pathname + url.search);
  $('html, body').scrollTop(0);
});
$(document).on('click', '.pls-pagination--btn', function (e) {
  e.preventDefault();
  DK.Search.updateListing(e.currentTarget.href);
  $('html, body').scrollTop(0);
});
$(document).on('click', '.pls-pagination__dropdown-item', function (e) {
  var pageNumber = $(e.currentTarget).data('value');
  var url = new URL(location.href);
  if (pageNumber === '1') {
    //remove page number parameter
    url.searchParams.delete('page');
  } else {
    //change existing page number or add a new one
    url.searchParams.set('page', pageNumber);
  }
  DK.Search.updateListing(url.pathname + url.search);
  $('html, body').scrollTop(0);
});
$(document).on('change', '.sort-select', function (e) {
  // Normalize sort option
  var sort = e.target.value.replace('+', '');
  var url = new URL(location.href);

  // Send user back to page one
  url.searchParams.delete('page');
  //replace existing sort or add a new one
  url.searchParams.set('sort', sort);
  DK.Search.updateListing(url.pathname + url.search);
  $('html, body').scrollTop(0);
});
$(document).on('click', '.pls-pagination__dd-item', function (e) {
  // Normalize sort option
  var sort = e.target.value.replace('+', '');
  var url = new URL(location.href);
  $(e.currentTarget).siblings().removeClass('pls-pagination__dd-item--active');
  $(e.currentTarget).addClass('pls-pagination__dd-item--active');

  // Send user back to page one
  url.searchParams.delete('page');
  //replace existing sort or add a new one
  url.searchParams.set('sort', sort);
  DK.Search.updateListing(url.pathname + url.search);
  $('html, body').scrollTop(0);
});
$(document).on('click', '.product-listing-container .prod__container a, .product-listing-container a.product', function () {
  let productFamilyItemId = $(this).data('skuId');
  if (!$(this).data('motorcycleTire') && $(this).data('skuId')) {
    Cookies.set('product_family_sku', productFamilyItemId, {
      expires: 1
    });
  } else {
    Cookies.remove('product_family_sku');
  }
  sessionStorage.setItem('scrollPos', window.scrollY);
  sessionStorage.setItem('scrollPage', window.location.href);
  return true;
});
$(document).on('click', '.pagination.pls-pagination__nav .page-item', function (e) {
  sessionStorage.setItem('scrollPos', window.scrollY);
  sessionStorage.setItem('scrollPage', window.location.href);
});
$(document).ready(function () {
  const scrollPos = sessionStorage.getItem('scrollPos');
  const scrollPage = sessionStorage.getItem('scrollPage');
  if (scrollPos !== null && scrollPage === window.location.href) {
    history.scrollRestoration = 'manual';
    window.scrollTo(0, scrollPos);
    sessionStorage.removeItem('scrollPos');
    sessionStorage.removeItem('scrollPage');
  } else {
    history.scrollRestoration = 'auto';
  }
});